import { SxProps, Theme } from '@mui/material';

export const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    menu: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '64px',
      listStyle: 'none',
      margin: 0,
      padding: 0,
      '& li': {
        position: 'relative',
        padding: `0 ${theme.spacing(2)}px`,
        fontSize: '1.6rem',
        '&:before': {
          position: 'absolute',
          left: 0,
          top: '50%',
          marginTop: '-9px',
          display: 'block',
          content: '""',
          height: '17px',
          width: '2px',
          background: '#e1e5e9',
        },
        '&:first-of-type:before': {
          display: 'none',
        },
        '& a': {
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          height: '64px',
          color: '#535863',
          textDecoration: 'none',
          '&.active, &:hover': {
            cursor: 'pointer',
            color: theme.palette.primary.dark,
          },
          '&.active': {
            pointerEvents: 'none',
          },
          '&.active:before, &:hover:before': {
            position: 'absolute',
            left: 0,
            bottom: 0,
            display: 'block',
            content: '""',
            height: '4px',
            width: '100%',
            borderRadius: '20px',
            background: theme.palette.secondary.main,
          },
        },
      },
    },
  };
};
